import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const updateMediaTag = async ({ slug, body }) => {
  const response = await axiosInstance.put(`/tags/${slug}/`, body);
  return response.data;
};

export const useUpdateMediaTag = (options = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...options,
    mutationFn: updateMediaTag,
    onSuccess: (data, variables) => {
      // Invalide le cache pour forcer un refetch des données
      queryClient.invalidateQueries({ queryKey: ['tags'] });

      // Appelle le callback onSuccess personnalisé s'il existe
      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
  });

  return {
    updateMediaTag: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
  };
};
